import React from 'react';
import PropTypes from 'prop-types';
import CategoryFilter from '../../../components/refinements/CategoryFilter';

export default function ProductFilters({
  currentCategory,
  onCategoryChanged,
  additionalData,
}) {
  return (
    <CategoryFilter
      currentCategory={currentCategory}
      onCategoryChanged={onCategoryChanged}
      additionalData={additionalData}
    />
  );
}

ProductFilters.propTypes = {
  currentCategory: PropTypes.string,
  onCategoryChanged: PropTypes.func,
  additionalData: PropTypes.objectOf(PropTypes.any),
};
